<template>
    <ItemPrice
        :hasDiscount="item.hasDiscount"
        :quantity="currentQuantity"
        :singlePrice="item.singlePrice"
        :singlePriceAfterDiscount="item.singlePriceAfterDiscount"
        :discountType="item.lastDiscountType"
    />
</template>

<script setup lang="ts">
    import type { ICartItem } from "@/data/model/Customer";
    import { computed } from "vue";

    import ItemPrice from "@/components/order/ItemPrice.vue";

    const props = defineProps<{
        item: ICartItem;
        quantity?: number;
    }>();

    const currentQuantity = computed(() => props.quantity ?? props.item.quantity);
</script>
